import axios from "axios";
//Limitless
import ClientContext from "@limitless/common/utils/client-context/ClientContext";
import { log as logger } from "@limitless/common/utils/Logging";
import { createPublicAPIRequest } from "@limitless/common/utils/PublicAPIUtils";
import { handleAPIFailure } from "@limitless/common/utils/api-log-helper/APILogHelper";
export const fetchCustomerHistory = (customer, callback) => {
  const log = logger.getLogger("HistoryActions fetchHistoryMessage");
  let additionalHeaders = null;
  const {
    customerEmailHash,
    customerKey
  } = customer;
  if (ClientContext._customerUtsc) {
    additionalHeaders = {
      UTSC: ClientContext._customerUtsc
    };
  }
  const path = `history/${customerEmailHash}`;
  const queryParams = {
    readonly: true,
    requester: "customer",
    tenantName: ClientContext._tenantName,
    groupName: ClientContext._groupName,
    filters: {
      archived: false
    },
    customerKey: ClientContext._customerKey || customerKey
  };
  const apiConfig = createPublicAPIRequest("get", path, queryParams, null, additionalHeaders);
  axios(apiConfig).then(res => {
    log.debug(res.data);
    callback(res.data);
  }).catch(error => {
    //2003 is Invalid UTSC token, we shouldn't inform the user
    const {
      shouldSupressError
    } = handleAPIFailure(error, "CustomerMessageHistoryAPI fetchHistoryMessage", null, {
      2003: true
    });
    callback({
      hasError: true,
      shouldSupressError
    });
  });
};